import type { ActionWithPayload } from "@model/Store.model";
import {
  ACCOUNT_MODE_MODAL_OPEN,
  ACCOUNT_MODE_MODAL_CLOSE,
  ACCOUNT_MODE_MODAL_RESET,
  ACCOUNT_MODE_MODAL_CHOOSE_GUEST,
} from "../AccountModeModal/AccountModeModalActionTypes";
import { LOGOUT_USER } from "Data/UserAuthentication/UserAuthenticationActionTypes";
import { AccountModeModalState } from "@model/AccountModeModal.model";

const INITIAL: AccountModeModalState = {
  visible: false,
  shownOnce: false,
};


export const AccountModeModalReducer = (
  state: AccountModeModalState = INITIAL,
  action: ActionWithPayload
): AccountModeModalState => {
  switch (action.type) {
    case ACCOUNT_MODE_MODAL_OPEN:
     if (state.shownOnce) return { ...state, visible: false };
      return { ...state, visible: true };
    case ACCOUNT_MODE_MODAL_CHOOSE_GUEST:
      return { ...state, visible: false, shownOnce: true };
    case ACCOUNT_MODE_MODAL_CLOSE:
      return { ...state, visible: false };
    case ACCOUNT_MODE_MODAL_RESET:
    case LOGOUT_USER:
      return { visible: false, shownOnce: false };
    default:
      return state;
  }
};
